import {
  createContext,
  useCallback,
  useMemo,
  useState,
} from 'react';

export const NavigationContext = createContext(null);

export function NavigationProvider({ children }) {
  const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);

  const openOffcanvas = useCallback(() => setOffcanvasOpen(true), []);
  const closeOffcanvas = useCallback(() => setOffcanvasOpen(false), []);
  const toggleOffcanvas = useCallback(
    () => setOffcanvasOpen((prev) => !prev),
    []
  );

  const value = useMemo(
    () => ({
      isOffcanvasOpen,
      openOffcanvas,
      closeOffcanvas,
      toggleOffcanvas,
    }),
    [isOffcanvasOpen, openOffcanvas, closeOffcanvas, toggleOffcanvas]
  );

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
}
